<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <platform-table />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
import PlatformTable from './PlatformTable'

export default {
  name: 'platform',
  components: {PlatformTable}
}
</script>



// WEBPACK FOOTER //
// src/views/game/platforms/Platform.vue